import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FcpButtonComponent } from './fcp-button.component';

@NgModule({
    declarations: [FcpButtonComponent],
    exports: [FcpButtonComponent],
    imports: [CommonModule]
})
export class FcpButtonModule {}
